import { useCallback, useEffect, useRef } from 'react';

const MAX_POLL_AMOUNT = 100;

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
const UX_MODE = 'redirect';
const SCOPES = 'email profile';
const PROMPT = 'select_account';

interface IGoogleLoginOptions {
  redirectUri: string;
  state?: string;
}

// eslint-disable-next-line consistent-return
const waitForGoogle = (count = 1): Promise<void> =>
  new Promise((resolve, reject) => {
    if ((window as any).google) {
      resolve(null);
    } else if (count >= MAX_POLL_AMOUNT) {
      reject(new Error('Google API not loaded'));
    } else {
      setTimeout(() => waitForGoogle(count + 1), 50);
    }
  });

export const useGoogleLogin = (options: IGoogleLoginOptions) => {
  const clientRef = useRef<any>();

  useEffect(() => {
    waitForGoogle()
      .then(() => {
        const client = (window as any).google?.accounts.oauth2.initCodeClient({
          client_id: CLIENT_ID,
          ux_mode: UX_MODE,
          scope: SCOPES,
          prompt: PROMPT,
          redirect_uri: options.redirectUri,
          state: options.state,
        });

        clientRef.current = client;
      })
      .catch(() => {
        // swallowing error
      });
  }, [options]);

  const googleAuthInit = useCallback(() => clientRef.current?.requestCode(), []);

  return googleAuthInit;
};
